import { render, staticRenderFns } from "./EventsView.vue?vue&type=template&id=3af1e0fb&scoped=true"
import script from "./EventsView.vue?vue&type=script&lang=ts"
export * from "./EventsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1e0fb",
  null
  
)

export default component.exports